<footer class="main-footer">
  <span class="footer-copy">
    <i class="fas fa-shield-alt"></i>
    SIGRP {{ year }} &middot;  Copyright &copy; &middot; Todos os direitos reservados.
  </span>
  <span class="footer-credit">
    Desenvolvido por <a target="_blank" href="http://nflsoftware.com">NFL Software</a>
  </span>
</footer>
